module.exports = __webpack_public_path__ + "static/media/agent2.8f0c9c10.png";